const CHECKBOX = 'CHECKBOX';
const DATE_PICKER = 'DATE_PICKER';
const DROPDOWN = 'DROPDOWN';
const DROPDOWN_WITH_TWO_LABELS = 'DROPDOWN_WITH_TWO_LABELS';
const DUMMY = 'DUMMY';
const INPUT_LR_BUTTONS = 'INPUT_LR_BUTTONS';
const MONEY_INPUT = 'MONEY';
const PHONE_NUMBER_INPUT = 'PHONE_NUMBER';
const RADIO_BUTTONS = 'RADIO_BUTTONS';
const RADIO_CHECKBOXES = 'RADIO_CHECKBOXES';
const REGULAR_INPUT = 'REGULAR_INPUT';
const SSN_INPUT = 'SSN';
const SWITCH_CHECKBOX = 'SWITCH_CHECKBOX';
const TEXTAREA = 'TEXTAREA';

export const INPUT_TYPES = {
    CHECKBOX,
    DATE_PICKER,
    DROPDOWN,
    DROPDOWN_WITH_TWO_LABELS,
    DUMMY,
    INPUT_LR_BUTTONS,
    MONEY_INPUT,
    PHONE_NUMBER_INPUT,
    RADIO_BUTTONS,
    RADIO_CHECKBOXES,
    REGULAR_INPUT,
    SSN_INPUT,
    SWITCH_CHECKBOX,
    TEXTAREA
};
